/* eslint-disable no-unused-vars */
/* eslint-disable sonarjs/sonar-no-unused-vars */
/* eslint-disable sonarjs/no-dead-store */
/* eslint-disable no-underscore-dangle */
import { Button } from '@salt/components';
import React, { useCallback, useState } from 'react';
import { moveUsers } from '../../api/users';
import MemberPicker from './create/MemberPicker';

const EditProjectMembersModal = ({ handleEditMembersModalClose, project, fetchData }) => {
  const [selected, setSelected] = useState([]);
  const [hasUpdated, setHasUpdated] = useState(false);

  const onSave = useCallback(() => {
    moveUsers({ projectId: project.id, userIds: selected.map((u) => u.id) })
      .then(() => {
        fetchData();
      })
      .catch(() => {
        console.error('Failed to delete project');
      });
    handleEditMembersModalClose();
  }, [project, selected]);

  return (
    <div id="dialog" className="overlay z-[100] fixed top-0 left-0 m-auto w-full h-full flex">
      <button
        type="button"
        className="fixed w-full h-full z-[99] bg-black/30"
        onClick={handleEditMembersModalClose}
      />
      <div className="z-[100] w-[583px] react-modal small bg-secondary-light px-8 py-7 bg-white m-auto rounded-lg">
        <div className="modal-title">
          <h2 className="w-full mb-6 font-[18px] text-center">Edit Project Members</h2>

          <br />

          <MemberPicker
            project={project}
            selected={selected}
            setSelected={setSelected}
            setHasUpdated={setHasUpdated}
            description={`Add or move team members to Project ‘${project.name}’.`}
          />

          <div>
            <br />
            <Button
              onClick={handleEditMembersModalClose}
              type="neutral"
              className="max-w-[146px] h-[36px] ml-auto"
              paddingClassName="px-6"
            >
              Cancel
            </Button>
            <Button
              onClick={onSave}
              type="positive"
              disabled={!hasUpdated}
              className="max-w-[146px] h-[36px] ml-auto float-right"
              paddingClassName="px-6"
            >
              Save
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditProjectMembersModal;
